import { gql } from '@apollo/client';

export const getPlaylist = gql`
  query getPlaylist($id: ID!) {
    getPlaylist(id: $id) {
      id
      name {
        languageCode
        value
      }
      courses {
        thumbnail {
          file {
            key
          }
        }
        id
        name {
          languageCode
          value
        }
      }
    }
  }
`;

export const listCourses = gql`
  query listCourses(
    $pagination: PaginationInput
    $filter: CourseFilter
    $organizationId: ID
  ) {
    listCourses(
      pagination: $pagination
      filter: $filter
      organizationId: $organizationId
    ) {
      id
      name {
        languageCode
        value
      }
      thumbnail {
        file {
          key
        }
      }
      archivedScheduledAt
    }
  }
`;
